import { render, staticRenderFns } from "./lsn_basic.vue?vue&type=template&id=63047476&scoped=true"
import script from "./lsn_basic.vue?vue&type=script&lang=js"
export * from "./lsn_basic.vue?vue&type=script&lang=js"
import style0 from "./lsn_basic.vue?vue&type=style&index=0&id=63047476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63047476",
  null
  
)

export default component.exports